/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice more GridCraft formulas`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习更多 GridCraft 公式`)
};

/**
* | output |
* | --- |
* | "Practice more GridCraft formulas" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Links_0_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_links_0_label as "gc.search_guides.gridcraft_excel_compatibility.sections.2.links.0.label" }